var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d80027;}.b{fill:none;}.c{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8801.996 7160)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 9.159,
    cy: 9.159,
    r: 9.159,
    transform: "translate(-8801 -7159.205)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8795.994 -7153.998)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M324,84l8,8",
    transform: "translate(-324 -84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M332,84l-8,8",
    transform: "translate(-324 -84)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8801.996 -7160)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M258,8a10,10,0,1,0,10,10A10,10,0,0,0,258,8Zm0,18.75A8.75,8.75,0,1,1,266.75,18,8.75,8.75,0,0,1,258,26.75Z",
    transform: "translate(-248 -8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M325.045,76.18a.615.615,0,0,0-.87,0l-3.563,3.563L317.05,76.18a.615.615,0,0,0-.87.87l3.563,3.563-3.563,3.563a.615.615,0,0,0,.87.87l3.563-3.563,3.563,3.563a.615.615,0,1,0,.87-.87l-3.563-3.563,3.563-3.563A.615.615,0,0,0,325.045,76.18Z",
    transform: "translate(-310.613 -70.613)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRejected);
export default __webpack_public_path__ + "static/media/ICO_Rejected.eab163018adda577082bc4a843af3e2c.svg";
export { ForwardRef as ReactComponent };